enum FlowAnnotationColorSource {
    COLOR = "color",
    NOTE_TYPE = "noteType"
}

export default FlowAnnotationColorSource;
